export default "__VITE_ASSET__klZY9Y0E__"